/**
 * @generated SignedSource<<a07bf9ea4bd202e1b85a34f170936052>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_versionProgress_VersionProgress$data = {
  readonly relatedWorkV2?: {
    readonly edges: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"relatedWorkHeading_versionProgress" | "relatedWorkProgressBar_versionProgress">;
    } | null | undefined>;
  };
  readonly " $fragmentSpreads": FragmentRefs<"issueProgressBar_versionProgress_IssuesProgressBar" | "issueProgressDetails_versionProgress" | "issuesHeading_versionProgress" | "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection">;
  readonly " $fragmentType": "ui_versionProgress_VersionProgress";
};
export type ui_versionProgress_VersionProgress$key = {
  readonly " $data"?: ui_versionProgress_VersionProgress$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_versionProgress_VersionProgress">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isDevopsFeatureDisabledInFedRamp"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "relatedWorkV2"
        ]
      }
    ]
  },
  "name": "ui_versionProgress_VersionProgress",
  "selections": [
    {
      "condition": "isDevopsFeatureDisabledInFedRamp",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "alias": "relatedWorkV2",
            "concreteType": "JiraVersionRelatedWorkV2Connection",
            "kind": "LinkedField",
            "name": "__version_relatedWorkV2_connection",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "concreteType": "JiraVersionRelatedWorkV2Edge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "relatedWorkHeading_versionProgress"
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "relatedWorkProgressBar_versionProgress"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "cursor"
                    },
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "__typename"
                        }
                      ]
                    }
                  ]
                },
                "action": "THROW",
                "path": "relatedWorkV2.edges"
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              }
            ]
          },
          "action": "THROW",
          "path": "relatedWorkV2"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "issuesHeading_versionProgress"
    },
    {
      "kind": "FragmentSpread",
      "name": "issueProgressBar_versionProgress_IssuesProgressBar"
    },
    {
      "kind": "FragmentSpread",
      "name": "issueProgressDetails_versionProgress"
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "adad2bb30e02991a2dcfd9cb2046e4c9";

export default node;
